import { useState } from "react";
import { AiOutlineSearch, AiFillCloseCircle } from "react-icons/ai";
import { GoLocation } from "react-icons/go";

const Search = ({ onSearch, loading, allLocations = [] }) => {
  const [criteria, setCriteria] = useState({ title: "", location: "" });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCriteria((prev) => ({ ...prev, [name]: value }));
  };

  const handleSearch = (e) => {
    e.preventDefault();
    onSearch(criteria);
  };

  const handleReset = (field) => {
    const updated = { ...criteria, [field]: "" };
    setCriteria(updated);
    onSearch(updated);
  };

  return (
    <section className="container pl-0 pr-0 mb-8 mt-8">
      <div className="bg-gradient-to-br from-slate-50 via-blue-50 to-slate-50 rounded-xl p-6 md:p-8 dark:from-slate-900 dark:via-slate-800 dark:to-slate-900 border border-slate-200 dark:border-slate-700 shadow-sm">
        <form onSubmit={handleSearch}>
          <div className="flex flex-col md:flex-row w-full gap-3 md:gap-4">
            {/* Job Title Text Input */}
            <div className="flex-1 relative">
              <div className="flex items-center gap-2 px-4 py-3 rounded-lg border border-slate-300 bg-white shadow-sm hover:border-blue-400 focus-within:border-blue-500 focus-within:ring-2 focus-within:ring-blue-100 transition-all duration-300 dark:bg-slate-800 dark:border-slate-600 dark:hover:border-blue-500 dark:focus-within:ring-blue-900">
                <AiOutlineSearch className="text-slate-400 text-lg flex-shrink-0 dark:text-slate-500" />
                <input
                  type="text"
                  name="title"
                  value={criteria.title}
                  onChange={handleChange}
                  placeholder="Search By Job Title..."
                  className="bg-transparent w-full text-slate-700 placeholder-slate-400 focus:outline-none font-medium dark:text-slate-200 dark:placeholder-slate-500"
                />
                {criteria.title && (
                  <AiFillCloseCircle
                    className="text-lg text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 cursor-pointer transition-colors flex-shrink-0"
                    onClick={() => handleReset("title")}
                  />
                )}
              </div>
            </div>

            {/* Location Dropdown */}
            <div className="flex-1 relative">
              <div className="flex items-center gap-2 px-4 py-3 rounded-lg border border-slate-300 bg-white shadow-sm hover:border-blue-400 focus-within:border-blue-500 focus-within:ring-2 focus-within:ring-blue-100 transition-all duration-300 dark:bg-slate-800 dark:border-slate-600 dark:hover:border-blue-500 dark:focus-within:ring-blue-900">
                <GoLocation className="text-slate-400 text-lg flex-shrink-0 dark:text-slate-500" />
                <select
                  name="location"
                  value={criteria.location}
                  onChange={handleChange}
                  className="bg-transparent w-full text-slate-700 focus:outline-none font-medium dark:text-slate-200 appearance-none cursor-pointer"
                >
                  <option value="">All Locations</option>
                  {allLocations.map((loc) => (
                    <option key={loc} value={loc}>{loc}</option>
                  ))}
                </select>
                {criteria.location && (
                  <AiFillCloseCircle
                    className="text-lg text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 cursor-pointer transition-colors flex-shrink-0"
                    onClick={() => handleReset("location")}
                  />
                )}
              </div>
            </div>

            {/* Search Button */}
            <button
              type="submit"
              disabled={loading}
              className="bg-[#ff9906] hover:bg-[#ff9906]/90 text-white font-semibold px-6 py-3 rounded-lg shadow-md hover:shadow-lg active:scale-95 transition-all duration-300 md:w-auto flex items-center justify-center gap-2"
            >
              {loading ? (
                <>
                  <div className="animate-spin border-2 border-white border-t-transparent rounded-full w-4 h-4" />
                  <span>Searching...</span>
                </>
              ) : (
                <>
                  <AiOutlineSearch className="text-lg" />
                  Search
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default Search;
